module.exports = new __parcel__URL__("WevrLogoSecondary.c31fdafd.svg").toString();